<div class="teal-header">
  <h3 class="modal-title">Remove Email From Zepto Suppression List</h3>
  <img class="close-icon" mat-dialog-close src="/assets/icons/Close_Icon.svg" alt="Close" matTooltip="Close" />
</div>

<mat-dialog-content class="dialog-container">
  <label class="label-bold">Email address</label>

  <form [formGroup]="form">
    <div class="inline-row">
      <mat-form-field appearance="outline" class="custom-input-field">
        <input matInput formControlName="email" placeholder="Email Address" />
        <mat-error *ngIf="form.controls.email.hasError('required')">
          Email is required.
        </mat-error>
        <mat-error *ngIf="form.controls.email.hasError('email') || form.controls.email.hasError('pattern')">
          Please enter a valid email address.
        </mat-error>
        <mat-error *ngIf="form.controls.email.hasError('maxlength')">
          Email cannot exceed 256 characters.
        </mat-error>
      </mat-form-field>

      <button mat-raised-button class="action-btn-teal" type="button" (click)="removeEmail()"
        [disabled]="form.invalid || isLoading" matTooltip="Remove Email">
        Remove
      </button>
    </div>
  </form>

  <div class="alert-box success" *ngIf="feedbackMessage && isSuccess">
    <img src="/assets/icons/yes_check.svg" class="alert-icon" />
    <span>{{ feedbackMessage }}</span>
  </div>

  <div class="alert-box error" *ngIf="feedbackMessage && !isSuccess">
    <img src="/assets/icons/no_cross.svg" class="alert-icon" />
    <span>{{ feedbackMessage }}</span>
  </div>

  <div class="custom-modal__footer">
    <div class="warning">
      <img src="/assets/icons/warning.svg" class="warning-icon" />
      <p>If a user's Email is deleted from Suppression List, that particular Email can receive Mails Sent From ZeptoMail.</p>
    </div>
  </div>
</mat-dialog-content>